export const no = {
    yourOrder: 'Din bestilling',
    welcome: 'Velkommen!',
    subtotal: 'Delsum (inkl. mva):',
    discount: 'Rabatt:',
    tax: 'Mva:',
    remainingPayment: 'Å betale:',
    refundDue: 'Tilbakebetaling:',
    change: 'Vekslepenger:',
    login: 'Logg inn med Microsoft-kontoen din',
    invalidTenant: 'Ugyldig tenant',
    invalidTenantMessage: 'Vi kunne ikke bekrefte denne tenanten. Sjekk lenken, eller kontakt support.',
    missingTenant: 'Tenant-parameter mangler',
    missingTenantMessage: 'Åpne appen med en URL som:',
    backToSetup: 'Tilbake til oppsett',
    backToSetupQuestion: 'Vil du tilbake til oppsettet?',
    resetApp: 'Tilbakestill displayet',
    resetAppQuestion: 'Slett alle lagrede innstillinger og påloggingsdata på denne enheten?',
    cancel: 'Avbryt',
    confirm: 'Bekreft',
    selectEnvironment: 'Velg et miljø',
    selectCompany: 'Velg et firma',
    selectPosUnit: 'Velg en kasseenhet',
    environment: 'Miljø:',
    company: 'Firma:',
    posUnit: 'Kasseenhet:',
    changeEnvironment: 'Bytt miljø',
    changeCompany: 'Bytt firma',
    changePosUnit: 'Bytt kasseenhet',
    lineOrder: 'Linjerekkefølge:',
    newestFirst: 'Nyeste først',
    oldestFirst: 'Eldste først',
    setInUrl: (setting) => `Satt i URL-en (${setting}) — endre det der.`,
    standbyAfterSale: 'Standby etter salg:',
    seconds: 'sekunder',
    displayUrl: 'Display-URL:',
    copyUrl: 'Kopier URL',
    copied: 'Kopiert',
    copyFailed: 'Kopiering mislyktes',
    autoConfirmPaused: 'Displayet starter ikke automatisk før du trykker Bekreft.',
    switchAccount: 'Bytt Microsoft-konto',
    clear: 'Nullstill',
    urlSettingsTitle: 'Hva som kan settes i URL-en',
    urlTenant: 'Microsoft tenant-ID (påkrevd)',
    urlPreselect: 'Forhåndsvelg oppsettstrinnene',
    urlAutoConfirm: 'Hopp over denne siden ved oppstart',
    urlLineOrder: 'newestFirst eller oldestFirst',
    urlStandbyDelay: 'Sekunder et fullført salg blir på skjermen, standard 180',
    urlColors: '6-sifret hex-farge uten #, f.eks. 75153b',
    urlLang: 'da dansk, de tysk, no norsk, ellers engelsk',
    urlCrane: 'On-premise-modus',
    urlOnPremiseLogin: 'On-premise-pålogging, sammen med environment og company',
    urlReset: 'Alene i URL-en: sletter lagrede innstillinger og påloggingsdata på denne enheten',
    holdToReturn: 'I appen: hold hvor som helst på skjermen i 5 sekunder for å gå tilbake til oppsettet.',
    missingTenantInUrl: 'Tenant mangler i URL-en. Åpne appen med ?tenant=<MS tenant id>.',
    fetchEnvironmentsFailed: 'Kunne ikke hente miljøer på denne tenanten, enten på grunn av en nettverksfeil eller manglende rettigheter.',
    fetchCompaniesFailed: 'Kunne ikke hente firmaer på denne tenanten, enten på grunn av en nettverksfeil eller manglende rettigheter.',
    fetchPosUnitsFailed: 'Kunne ikke hente kasseenheter på denne tenanten, enten på grunn av en nettverksfeil eller manglende rettigheter.',
    autoStartMissing: (settings) => `Autostart stoppet: URL-en mangler ${settings}.`,
    autoStartNotFound: (setting, urlValue) => `Autostart stoppet: ${setting} '${urlValue}' fra URL-en ble ikke funnet.`,
};
